import { render, staticRenderFns } from "./ListRoomZoomJoin.vue?vue&type=template&id=47d253bf&scoped=true"
import script from "./ListRoomZoomJoin.vue?vue&type=script&lang=js"
export * from "./ListRoomZoomJoin.vue?vue&type=script&lang=js"
import style0 from "./ListRoomZoomJoin.vue?vue&type=style&index=0&id=47d253bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d253bf",
  null
  
)

export default component.exports